module.exports = __webpack_public_path__ + "media/images/landing_page/2023/tools/vision_ru_mobile-49075422be5e8d8273f65750bef84827.webp";